import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

const PublicRoute = () => {
  const { user, loading } = useAuth();

  // 1️⃣ Wait until auth state is ready
  if (loading) return null;

  // 2️⃣ If logged in, redirect based on ROLE
  if (user) {
    return user.role === "ADMIN" ? (
      <Navigate to="/admin/dashboard" replace />
    ) : (
      <Navigate to="/dashboard" replace />
    );
  }

  // 3️⃣ Guest users can access public pages
  return <Outlet />;
};

export default PublicRoute;
